import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { BillsVService } from '../../services/V2/gozer';
import { handleError } from '../shared/Functions';

export const Bill = ({ bill, billingAccountId, setOpen }) => {
    const [src, setSrc] = useState<string>("");

    useEffect(() => {
        if(bill && billingAccountId){
            BillsVService.billsVGetAttachment(billingAccountId, bill.id)
                .then(m => setSrc(m.preSignedUrl ?? "error"))
                .catch(err => {
                    setSrc("error");
                    handleError(err);
                })
        }
    }, [bill, billingAccountId])

    const handleCancel = () => {
        setOpen(false)
    }

    return (<>
    <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Bill</DialogTitle>
            <DialogContent style={{ width: "600px", height: "100vh" }}>
                {src === "" ?
                    <div style={{ textAlign:"center" }}>Loading...</div> :
                    src === "error" ?
                    <div style={{ textAlign:"center" }}>There was an error loading the bill.</div> :
                    <iframe title="bill" style={{ width: "100%", height: "100vh" }} src={src} />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    </>);
}